export const useLibraryStrategyForm = (): UseLibraryStrategy => {
  const type = 'form';
  const localRoute = ref<string>('');
  const route = useRoute();

  const slugs = computed<string[]>(() => {
    let parts = localRoute.value.split('/');

    if (parts.length === 1 && parts[0] === '') {
      parts = [];
    }
    return parts;
  });

  const hasPrevious = computed(() => slugs.value.length > 0);

  const path = computed(() => {
    return localRoute.value ? `${route.path}/${localRoute.value}` : route.path;
  });

  const setRoute = (path) => {
    localRoute.value = path.replace(route.path + '/', '');
  };
  const goBack = () => {
    const paths = localRoute.value.split('/');
    paths.splice(-1);
    const newRoute = paths.join('/');
    setRoute(newRoute);
  };

  watchEffect(() => {
    globalThis.$logger.info(
      'useLibraryStrategyForm :: slugs',
      slugs.value,
      slugs.value.length,
      'hasPrevious',
      hasPrevious.value
    );
  });

  return {
    type,
    slugs,
    setRoute,
    goBack,
    path,
    hasPrevious,
  };
};
